export const PERSON_ALL_ID = 'all';
export const PERSON_UNASSIGNED_ID = 'unassigned';

export const PERSON_ALL = Object.freeze({ id: PERSON_ALL_ID, name: 'All sales people' });
export const PERSON_UNASSIGNED = Object.freeze({ id: PERSON_UNASSIGNED_ID, name: 'Unassigned' });

export function getSelfSalesPerson(user, salesPersons = []) {
  const employeeId = user?.employee?.id;
  if (employeeId) {
    const match = salesPersons.find((person) => person.id === employeeId);
    if (match) {
      return match;
    }
    return { id: employeeId, name: user?.name || user?.employee?.name || 'You' };
  }
  if (user?.name) {
    const match = salesPersons.find((person) => person.name === user.name);
    if (match) {
      return match;
    }
  }
  return null;
}

export function getPersonPickerOptions({ can, salesPersons, self }) {
  if (can?.pickerLocked) {
    if (!self) {
      return [];
    }
    return [{ id: self.id, name: `${self.name} (you)` }];
  }

  const options = [{ ...PERSON_ALL }];
  if (can?.showUnassignedOption) {
    options.push({ ...PERSON_UNASSIGNED });
  }
  return options.concat(salesPersons || []);
}

export function isScopedPerson(person) {
  return Boolean(person?.id) && person.id !== PERSON_ALL_ID;
}

export function salesPersonToRequest(person) {
  if (!isScopedPerson(person)) {
    return undefined;
  }
  return { id: person.id, name: person.name };
}

export function findSalesPersonById(salesPersons, id) {
  if (!id) {
    return null;
  }
  if (id === PERSON_ALL_ID) {
    return PERSON_ALL;
  }
  if (id === PERSON_UNASSIGNED_ID) {
    return PERSON_UNASSIGNED;
  }
  return (salesPersons || []).find((person) => person.id === id) || null;
}

export function findSalesPersonByName(salesPersons, name) {
  if (!name) {
    return null;
  }
  return (salesPersons || []).find((person) => person.name === name) || null;
}
